import { render, staticRenderFns } from "./FullLayout.vue?vue&type=template&id=0671ac5c&"
import script from "./FullLayout.vue?vue&type=script&lang=ts&"
export * from "./FullLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports